import {AppBar, Toolbar, Typography} from "@mui/material";
import React from "react";
import {AccountMenu} from "./AccountMenu";
import {translateFunction} from "../../localization/TranslationService";
import {Slot} from "nano-slots";

const translate = translateFunction();

const tagsSlotName = "tags";

export function Header() {
	return <AppBar position={"relative"}>
		<Toolbar>
			<Typography variant={"h6"} noWrap={true} style={{
				flexGrow: 1.0,
			}}>
				{translate("Kizi Portal")}
			</Typography>
			
			<Slot name={tagsSlotName}/>
			
			<AccountMenu/>
		</Toolbar>
	</AppBar>;
}
